<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>交易管理</el-breadcrumb-item>
        <el-breadcrumb-item>退单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="订单编号：">
              <el-input
                size="small"
                v-model="listParams.orderNum"
                placeholder="请输入订单编号"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <date-components
              start-prop="chargeBackDate"
              :start-date="listParams.chargeBackDate"
              @set-start-date="getStartDate"
              date-width="100%"
              date-type="date"
              show-type="left"
              label-name="退单时间："
            >
            </date-components>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary">
                查询
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-radio-group v-model="isAudit" size="small">
            <el-radio-button label="01">未审核</el-radio-button>
            <el-radio-button label="02">已审核</el-radio-button>
          </el-radio-group>
          <span class="table-info-display">
            <el-button
              style="margin-right:20px;"
              type="primary"
              size="small"
              @click="exportData"
            >
              导出
            </el-button>
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span
              v-text="
                (pager.pageIndex > 1
                  ? (pager.pageIndex - 1) * pager.pageSize
                  : 0) +
                  scope.$index +
                  1
              "
            >
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="orderNum" align="center" label="订单编号">
        </el-table-column>

        <el-table-column prop="buyerInfo" align="center" label="买家信息">
        </el-table-column>

        <el-table-column prop="orderMoney" align="center" label="订单金额(元)">
          <template slot-scope="scope">
            <span>{{ scope.row.orderMoney | formatToFixed2 }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="orderDate" align="center" label="下单日期">
          <template slot-scope="scope">
            {{ scope.row.orderDate | formatDate }}
          </template>
        </el-table-column>

        <el-table-column prop="payWay" align="center" label="支付方式">
        </el-table-column>

        <el-table-column prop="supplyCentre" align="center" label="供应点">
        </el-table-column>

        <el-table-column prop="chargeBackDate" align="center" label="退单时间">
          <template slot-scope="scope">
            {{ scope.row.chargeBackDate | formatDate }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template>
            <el-button type="text">详情</el-button>
            <el-button type="text">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog
      class="hx-to-create-template"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      @close="resetDialogForm"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          ref="dialogForm"
          :model="itemParams"
          :rules="checkItemParams"
          label-width="120px"
        >
          <el-form-item label="分类名称 ：" prop="categoryName">
            <el-input
              v-model="itemParams.categoryName"
              size="small"
              placeholder="请输入分类名称"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="序号：" prop="sort">
            <el-input-number
              size="small"
              v-model="itemParams.sort"
              :min="1"
              label="描述文字"
            ></el-input-number>
          </el-form-item>

          <el-form-item>
            <el-button
              size="small"
              type="primary"
              @click="saveCategoryNameItem"
            >
              保 存
            </el-button>

            <el-button size="small" @click="dialogVisible = false">
              取 消
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        orderNum: "",
        chargeBackDate: ""
      },
      isAudit: "01",
      tableLoading: false,
      tableData: [
        {
          ID: "1",
          orderNum: 123,
          buyerInfo: "哈哈哈",
          orderMoney: 2.4,
          orderDate: 1523072550284,
          payWay: "支付宝",
          supplyCentre: "供应点1",
          chargeBackDate: 1523072550284
        },
        {
          ID: "2",
          orderNum: 123,
          buyerInfo: "哈哈哈",
          orderMoney: 2.4,
          orderDate: 1523072550284,
          payWay: "支付宝",
          supplyCentre: "供应点1",
          chargeBackDate: 1523072550284
        },
        {
          ID: "3",
          orderNum: 123,
          buyerInfo: "哈哈哈",
          orderMoney: 2.4,
          orderDate: 1523072550284,
          payWay: "支付宝",
          supplyCentre: "供应点1",
          chargeBackDate: 1523072550284
        },
        {
          ID: "4",
          orderNum: 123,
          buyerInfo: "哈哈哈",
          orderMoney: 2.4,
          orderDate: 1523072550284,
          payWay: "支付宝",
          supplyCentre: "供应点1",
          chargeBackDate: 1523072550284
        }
      ],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      dialogTitle: "新增分类管理条目",
      dialogVisible: false,
      itemParams: {
        categoryName: "",
        sort: 4
      },
      checkItemParams: {
        categoryName: [
          { required: true, message: "请输入分类名称", trigger: "blur" }
        ],
        sort: [{ required: true, message: "请输入序号", trigger: "blur" }]
      }
    };
  },
  mounted() {},
  methods: {
    /**
     * 父组件获取子组件传递的开始日期
     * @param startAttr
     * @param startDate
     */
    getStartDate(startAttr, startDate) {
      if (startDate !== "") {
        this.itemParams[startAttr] = new Date(startDate).getTime();
      } else {
        this.itemParams[startAttr] = "";
      }
    },
    /**
     * 导出
     */
    exportData() {},
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
    },
    /**
     * 保存新增或修改
     */
    saveCategoryNameItem() {},
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
